import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const I18N_CONTEXT_SYMBOL = Symbol();
const useI18n = ()=>useImmutableContext(I18N_CONTEXT_SYMBOL);
const useI18nProvider = (...args)=>useImmutableContextProvider(I18N_CONTEXT_SYMBOL, ...args);
export { useI18n, useI18nProvider };
